import { render, staticRenderFns } from "./TakipEkAlanForm.vue?vue&type=template&id=2caded13"
import script from "./TakipEkAlanForm.vue?vue&type=script&lang=ts"
export * from "./TakipEkAlanForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports